export default [
  {
    path: '/system/setting',
    name: 'system-setting',
    component: () => import('@/views/system/setting.vue'),
    meta: {
      resource: 'system',
      action: 'update',
      pageTitle: 'System Setting',
      breadcrumb: [
        {
          text: 'System Setting',
          active: true,
        },
      ],
    },
  },
]
